// extracted by mini-css-extract-plugin
export default {"tags":"Tags-module--tags--29f2e","nowrapTag":"Tags-module--nowrapTag--1e50c","tag":"Tags-module--tag--c0147"};